// extracted by mini-css-extract-plugin
module.exports = {"box":"style__box__vHJcb","button":"style__button__vmz+2"};